import { ProductResponse } from "../../../../types/product.type";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { COMPACT_QUERY } from "../../../../utils/hooks/useCompact";

const compact = "@media " + COMPACT_QUERY;

const FRAME_HEIGHT = 150;
const COMPACT_FRAME_HEIGHT = 120;

interface ImageInfoProps {
  productDetails: ProductResponse;
}

interface ImageSlotProps {
  title: string;
  caption: string;
  imageUrl: string | null;
}

const ImageSlot = ({ title, caption, imageUrl }: ImageSlotProps) => (
  <Box sx={{ flex: 1, minWidth: 0 }}>
    <Typography variant="body2" fontWeight={700}>
      {title}
    </Typography>
    <Typography
      variant="caption"
      sx={{ color: (theme) => theme.palette.gray.main }}
    >
      {caption}
    </Typography>
    <Box
      sx={{
        height: FRAME_HEIGHT,
        [compact]: { height: COMPACT_FRAME_HEIGHT },
        mt: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 2,
        border: (theme) => `1px solid ${theme.palette.background.default}`,
      }}
    >
      {imageUrl ? (
        <Box
          component="img"
          alt={title}
          src={imageUrl}
          sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
        />
      ) : (
        <Typography variant="body2" color="text.secondary">
          ไม่มีรูปภาพ
        </Typography>
      )}
    </Box>
  </Box>
);

/** The product's two image slots, shown side by side inside the details card. */
export default function ImageInfo({ productDetails }: ImageInfoProps) {
  return (
    <Stack direction={{ xs: "column", sm: "row" }} gap={2}>
      <ImageSlot
        title="รูปภาพ Icon Thumbnail"
        caption="ขนาด 150 x 150px"
        imageUrl={productDetails.thumbnail}
      />
      <ImageSlot
        title="รูปภาพ Coverpage"
        caption="ขนาด 390 x 250px"
        imageUrl={productDetails.picture}
      />
    </Stack>
  );
}
